import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from '../Header';
import Footer from '../Footer';
import './theme.css';
import curtainsBlackout from '../../src/image/curtains-blockout.jpg';
import Breadcrumbs from './Breadcrumbs';
function Curtains() {

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    const keyFeatures = [
        { icon: 'bi-check-circle-fill', desc: ' Custom measurements & professional stitching' },
        { icon: 'bi-check-circle-fill', desc: ' Durable fittings & smooth operation' },
        { icon: 'bi-check-circle-fill', desc: ' Light filtering, room darkening & full blackout options' },
        { icon: 'bi-check-circle-fill', desc: ' Manual and motorized curtain systems' },
        { icon: 'bi-check-circle-fill', desc: ' Professional installation service' },
    ]

    const features = [
        { title: 'Custom Measurements & Stitching', desc: 'Precise tailoring to fit any window size with professional finishes and durable seams.' },
        { title: 'Light Control & Privacy', desc: 'From airy sheers to full blackout fabrics — choose the right level of light and privacy.' },
        { title: 'Motorized Options', desc: 'Smart, remote-controlled systems for effortless operation and luxury automation.' }
    ];

    const typesOfCurtains = [
        { icon: 'bi-check-circle-fill', title: ' Eyelet Curtains (Ring-Top)', desc: 'Modern, easy-to-slide design that suits living rooms, bedrooms and offices.' },
        { icon: 'bi-check-circle-fill', title: ' Pinch Pleat Curtains', desc: 'Classic pleated style for luxury homes, hotels, and premium interiors.' },
        { icon: 'bi-check-circle-fill', title: ' Tab Top Curtains', desc: 'Minimalist and stylish — perfect for casual and contemporary spaces.' },
        { icon: 'bi-check-circle-fill', title: ' Wave / Ripple Fold Curtains', desc: 'Smooth, flowing drape for large windows and corporate interiors.' },
        { icon: 'bi-check-circle-fill', title: ' Sheer Curtains', desc: 'Adds softness and diffused natural light while preserving a premium look.' },
        { icon: 'bi-check-circle-fill', title: ' Blackout Curtains', desc: 'Complete light blocking and privacy — ideal for bedrooms and media rooms.' },
        { icon: 'bi-check-circle-fill', title: ' Motorized Curtains', desc: 'Smart automation for effortless operation — great for luxury and commercial spaces.' },
    ];

    return (
        <div className="container-fluid p-0 ">
            <Header />

            <section className="theme-section">
                <Breadcrumbs/>
                <div className="container" data-aos="fade-up">
                    <div className="theme-section-title text-center">
                        <h2>Premium Custom-Made Window Curtains for Homes & Commercial Interiors</h2>
                        <p>Beautifully crafted curtains using high-quality <strong>crush, blackout, sheers, and designer fabrics</strong>. Tailored styles for residences, offices, hotels and commercial spaces — with manual and motorized options.</p>
                    </div>

                    <div className="features">
                        {features.map((feature, idx) => (
                            <div key={idx} className="feature" data-aos="fade-up">
                                <h4>{feature.title}</h4>
                                <p className="small muted">{feature.desc}</p>

                            </div>
                        ))}
                    </div>

                    {/* Tab Content */}
                    <div className="theme-row" data-aos="fade-up">
                        <div className="col-lg-6 theme-col">
                            <h6>Key Features</h6>
                            <ul className="theme-features">
                                {keyFeatures.map((item, idx) => (
                                    <li key={idx}>
                                        <i className={`bi ${item.icon}`}></i> {item.desc}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="col-lg-6 theme-col theme-image-wrapper" data-aos="zoom-in">
                            <img src={curtainsBlackout} alt="Curtains" className="theme-image" />
                        </div>
                    </div>

                  
                       <div className="theme-row" data-aos="fade-up">
                        <div className="col-lg-6 theme-col">
                                <h6>Types of Curtains We Stitch</h6>
                                <ul className="theme-features">
                                    {
                                        typesOfCurtains.map((item, idx) => (
                                            <li key={idx}>
                                                <i className={`bi ${item.icon}`}></i>
                                                <span>{item.title}:</span> {item.desc}
                                            </li>
                                        ))}
                                </ul>
                            </div>
                        </div>
                 

                    <div className='theme-row' data-aos="fade-up">
                        <div className='theme-row' data-aos="fade-up">
                            <div className="theme-col">
                                <h6>Fabrics & Materials</h6>
                                <p className='muted small'>We use a curated selection of premium fabrics for style, durability and performance.</p>
                                <div className="fabric-list">
                                    <div className="chip">Crush Fabrics</div>
                                    <div className="chip">Blackout Materials</div>
                                    <div className="chip">Sheer Fabrics</div>
                                    <div className="chip">Designer Prints</div>
                                    <div className="chip">Textured Weaves</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='theme-row' data-aos="fade-up">
                        <div className='theme-row'>
                            <div className="theme-col">
                                <h6>Where Our Curtains Are Ideal</h6>
                                <p className='muted small'>Perfect solutions for both residential and commercial projects.</p>
                                <div className='ideal-places'>
                                    <div className="chip">Homes & Apartments</div>
                                    <div className="chip">Offices</div>
                                    <div className="chip">Hotels & Resorts</div>
                                    <div className="chip">Showrooms</div>
                                    <div className="chip">Hospitals & Clinics</div>
                                    <div className="chip">Educational Institutions</div>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* Feature Boxes */}
                    <div className="row theme-feature-section" data-aos="fade-up">
                        <div className="theme-feature-box">
                            <p className="theme-feature-description">“Style your windows with premium, custom-made curtains—crafted for lasting beauty in every home and commercial space.”</p>
                        </div>
                    </div>

                </div>
                
            </section>

            <Footer />
        </div>
    );
}

export default Curtains;
